import React from 'react';
import cn from 'class-names';

import Input from '@uikit/Form/Input/Input';

import './BillingFormField.scss';

const BillingFormField = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  className = '',
  disabled = false,
  isError = false,
  errorMessage,
  hint,
  maxLength,
  children,
  testId,
}: {
  id?: string;
  label: string;
  value?: string;
  onChange?: (val: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  isError?: boolean;
  errorMessage?: string;
  hint?: React.ReactNode;
  maxLength?: number;
  children?: React.ReactNode;
  /** data-testid of the field; its input gets `${testId}-input`, its error `${testId}-error`. */
  testId?: string;
}): JSX.Element => {
  const handleChangeValue = ({ target: { value: inputValue } }) => {
    if (onChange) {
      onChange(inputValue);
    }
  };

  return (
    <div
      className={cn('billing-form-field', {
        [className]: className.length > 0,
        'billing-form-field--error': isError,
      })}
      data-testid={testId}
    >
      {label ? (
        <label className="billing-form-field__label" htmlFor={id}>
          {label}
        </label>
      ) : null}
      <div className="billing-form-field__field">
        {children || (
          <Input
            id={id}
            value={value}
            onChange={handleChangeValue}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            isError={isError}
            isFullWidth
            maxLength={maxLength}
            aria-invalid={isError || undefined}
            aria-describedby={isError && id ? `${id}-error` : undefined}
            data-testid={testId ? `${testId}-input` : undefined}
          />
        )}
      </div>
      {!isError && !!hint && <div className="billing-form-field__hint">{hint}</div>}
      {!!errorMessage && (
        <div
          className="billing-form-field__error-message"
          id={id ? `${id}-error` : undefined}
          role="alert"
          data-testid={testId ? `${testId}-error` : undefined}
        >
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default BillingFormField;
